// import React from "react";
import { Helmet } from "react-helmet";
export default function HelmetMetaData(props)
{
//    let location = window.location;
//    let currentUrl = "http://poplify.com" + location.pathname;
   let currentUrl = "https://hiring.heartpace.com"
   let quote = props.quote !== undefined ? props.quote : "";
   let title = props.title !== undefined ? props.title : "Candidly - Jobs searching is easy now.";
   let image = props.image !== undefined ? props.image : "https://poplify.com/wp-content/uploads/2020/08/Team-Poplify-1536x658.jpg";
   let description = props.description !== undefined ? props.description  : "Candidly Jobs";
   let hashtag = props.hashtag !== undefined ? props.hashtag : "#candidly";
   let allowIframe = window.location.pathname.startsWith('/careers')
return (
 <Helmet>
     <title>{title}</title>
     <meta charset="utf-8" />
     <meta name="csrf_token" content="" />
     <meta property="type" content="website" />
     <meta property="url" content={currentUrl} />
     <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>
     <meta name="msapplication-TileColor" content="#ffffff" />
     <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
     <meta name="theme-color" content="#ffffff" />
     <meta name="_token" content="" />
     <meta name="robots" content="noodp" />
     <meta property="title" content={title} />
     <meta property="quote" content={quote} />
     <meta name="description" content={description} />
     <meta property="image" content={image} />
     <meta property="og:locale" content="en_US" />
     <meta property="og:type" content="website" />
     <meta property="og:title" content={title} />
     <meta property="og:quote" content={quote} />
     <meta property="og:hashtag" content={hashtag} />
     <meta property="og:image" content={image} />
     <meta content="image/*" property="og:image:type" />
     <meta property="og:url" content={currentUrl} />
     <meta property="og:site_name" content="Candidly" />
     <meta property="og:description" content={description} />    
     {/* <script type={"application/ld+json"}>{`${JSON.stringify(props.job_script)}`}</script> */}
    {/* Clickjacking Defensive script */}
    {!allowIframe && <style id="antiClickjack">{`
        body{display:none !important;}`
      }
    </style>}
    {!allowIframe && <script type="text/javascript">{`
      if (self === top) {
        let x = 0;
        let intervalID = setInterval(function () {
          var antiClickjack = document.getElementById("antiClickjack");
          if(antiClickjack) antiClickjack.parentElement.removeChild(antiClickjack);
          if (++x === 5) {
            window.clearInterval(intervalID);
          }
        }, 100);
      } else {
        top.location = self.location;
      }`
    }
    </script>
    }

    </Helmet>
);
}